module.exports = __webpack_public_path__ + "static/media/chrome-logo.d60a042e.svg";